import { createFileRoute } from "@tanstack/react-router"
import { FiFileText, FiLink, FiPlusCircle } from "react-icons/fi"
import {
  type ProductionModuleCard,
  ProductionModuleHubPage,
} from "../../../../components/WMS/ProductionNavigation/ProductionModuleHubPage"

const cards: ProductionModuleCard[] = [
  {
    title: "Zlecenia produkcyjne",
    description:
      "Przeglądaj, filtruj i obsługuj bieżące oraz zakończone zlecenia.",
    to: "/WMS/production-orders/production-orders-list",
    icon: FiFileText,
  },
  {
    title: "Nowe zlecenie",
    description:
      "Utwórz zlecenie produkcyjne na podstawie wybranej technologii.",
    to: "/WMS/production-orders/create",
    icon: FiPlusCircle,
  },
  {
    title: "Łańcuch produkcji",
    description:
      "Śledź powiązania zleceń, zapotrzebowanie materiałowe i kolejne etapy.",
    to: "/WMS/production-orders/chain",
    icon: FiLink,
  },
]

export const Route = createFileRoute("/_layout/WMS/production-orders/")({
  component: ProductionOrdersHubRoute,
})

function ProductionOrdersHubRoute() {
  return (
    <ProductionModuleHubPage
      title="Produkcja"
      description="Zlecenia produkcyjne, szybkie rozpoczęcie pracy i podgląd całego łańcucha."
      cards={cards}
    />
  )
}
